export default __webpack_public_path__ + "static/background-verification-6a84273eca1edebce694f3d1c8f8242f.gif";